<template>
  <b-button
    variant="primary"
    :disabled="processando || !habilitado">
      <slot v-if="!processando"></slot>
      <span v-if="processando"><i class="fa fa-circle-o-notch fa-spin"></i>&nbsp; PROCESSANDO</span>
  </b-button>
</template>

<script>
export default {
  name: 'ButtonSpinner',
  props: {
    processando: {
      type: Boolean,
      default: false
    },
    habilitado: {
      type: Boolean,
      default: true
    },
    tipo: {
      type: String,
      default: 'primary'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ButtonSpinner.vue